<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents" v-if="!isRendering">
      <h1 class="l-pageTitle">トライアル申込情報</h1>
      <div class="l-contentsBox">
        <div class="l-diagnosisSearch">
          <div class="l-diagnosisSearch__header" @click="showSearch(!isSearch)">
            <p class="l-diagnosisSearch__label"><img src="@/assets/img/common/icon-search.svg" alt="">絞り込み</p>
          </div>
          <transition name="trialsearch-fade">
            <div class="l-diagnosisSearch__body" v-show="isSearch">
              <div class="l-diagnosisSearch__section">
                <div class="l-formGroup">
                  <label class="l-formGroup__label">確定ステータス</label>
                  <label class="l-checkbox">
                    <CheckBox v-model="searchForm.isIncludeCompleted" :value="true" :checked="searchForm.isIncludeCompleted" labelText="確定済も含む" />
                  </label>
                </div>
              </div>
              <div class="l-diagnosisSearch__bottom">
                <div class="btn-basic is-inlne" @click="getTrialEntryList(1)"><a>絞り込む</a></div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="l-grayBox mt-30">
        <div class="l-infoResult">
          <p><span>検索結果：</span>{{ pageInfo.total }}件</p>
        </div>
      </div>
      <table class="table-base audit-table table-select mt-30">
        <colgroup>
          <col style="width: 120px;">
          <col style="width: 100px;">
          <col style="width: 200px;">
          <col style="width: 200px;">
          <col style="width: 150px;">
        </colgroup>
        <thead>
          <tr>
            <th>確定日時</th>
            <th>申込先</th>
            <th>申込日時</th>
            <th>社名</th>
            <th>担当者名</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="trialEntry in trialEntryList" :key="trialEntry.trialEntryId" @click="goConfirm(trialEntry.trialEntryId)">
            <td>
              <span v-if="trialEntry.trialEntryConfirmDate">確定済({{ $dayjs(trialEntry.trialEntryConfirmDate).format("YYYY/MM/DD HH:mm") }})</span>
            </td>
            <td>{{ trialEntry.entryPlanName }}</td>
            <td>{{ $dayjs(trialEntry.trialEntryDate).format("YYYY/MM/DD HH:mm") }}</td>
            <td>{{ trialEntry.corpName }}</td>
            <td>{{ trialEntry.responsibleName }}</td>
          </tr>
        </tbody>
      </table>
      <pagination
        :pageInfo="pageInfo"
        @change-page="emitChangePage">
      </pagination>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Pagination from '@/components/parts/common/Pagination.vue';
import CheckBox from '@/components/parts/form/CheckBox.vue';

export default {
  components: {
    Loading,
    Pagination,
    CheckBox,
  },
  data() {
    return {
      isProcessing: false,
      isRendering: false,
      isSearch: false,
      pageInfo: {},
      searchForm: {
        isIncludeCompleted: false,
      },
      trialEntryList: []
    }
  },
  created: async function () {
    await this.getTrialEntryList(1);
  },
  methods: {
    emitChangePage(page) {
      this.getTrialEntryList(page)
    },
    showSearch(value) {
      this.isSearch = value;
    },
    async getTrialEntryList(page) {
      this.isProcessing = true;
      this.isRendering = true;
      let res = await this.$axios.post('/ld/api/contact/trial_entry/getTrialEntryList', {
        page: page,
        isIncludeCompleted: this.searchForm.isIncludeCompleted
      });
      if (res) {
        this.trialEntryList = res.data.trialEntryList.data;
        this.pageInfo = {
          currentPage: res.data.trialEntryList.current_page,
          lastPage: res.data.trialEntryList.last_page,
          total: res.data.trialEntryList.total,
          from: res.data.trialEntryList.from,
          to: res.data.trialEntryList.to,
        };
        this.isSearch = false;
      }
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });

    },
    goConfirm(trialEntryId) {
      this.$store.dispatch('trialEntry/setTrialEntryId', trialEntryId);
      this.$router.push({ name: 'trial-entry-confirm' });
    }
  }
}
</script>

<style scoped>
.trialsearch-fade-enter-active {
  transition: height .1s ease-in-out;
}
.trialsearch-fade-leave-active {
  transition: height .1s ease-in-out;
}
.trialsearch-fade-enter-to, .trialsearch-fade-leave {
  overflow: hidden;
}
.trialsearch-fade-enter, .trialsearch-fade-leave-to {
  overflow: hidden;
}
</style>
